import React from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import aboutImage1 from '../assets/ashan/1.jpeg';
import aboutImage2 from '../assets/ashan/47.jpeg';
import aboutImage3 from '../assets/ashan/19.jpeg';
import aboutImage4 from '../assets/ashan/18.jpeg';
import aboutImage5 from '../assets/ashan/13.jpeg';
import villaImage1 from '../assets/images/edited/WhatsApp Image 2025-10-02 at 19.45.17-Photoroom.png';
import villaImage2 from '../assets/images/edited/15-Photoroom.png';
import villaImage3 from '../assets/images/12.jpeg';
import villaImage4 from '../assets/images/7.jpeg';
import villaImage5 from '../assets/images/WhatsApp Image 2025-10-02 at 19.50.18.jpeg';

const About = () => {
    const { t } = useTranslation();

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
        cssEase: 'ease-in-out',
        appendDots: (dots) => (
            <div>
                <ul className="flex justify-center space-x-2">{dots}</ul>
            </div>
        ),
        customPaging: () => (
            <div className="w-3 h-3 bg-gray-400 rounded-full hover:bg-[#C58E2F] transition"></div>
        ),
    };

    const aboutImages = [aboutImage1, aboutImage2, aboutImage3, aboutImage4, aboutImage5];
    const villaImages = [villaImage1, villaImage2, villaImage3, villaImage4, villaImage5];

    return (
        <div className="p-4 sm:p-8 font-customFont bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen">
            {/* Introduction Section */}
            <div className="max-w-7xl mx-auto mt-16">
                {/* Layout for sm and md screens: Title, Slider, Paragraphs, all centered */}
                <div className="block lg:hidden">
                    <div className="flex flex-col items-center space-y-8">
                        {/* Title, centered */}
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#122C56] mb-6 animate-fade-in text-center drop-shadow-md">
                            {t('aboutSection.travelWithAshan')}
                        </h1>
                        {/* Image Slider, centered */}
                        <div className="w-full max-w-3xl">
                            <Slider {...sliderSettings} className="rounded-xl shadow-xl overflow-hidden">
                                {aboutImages.map((image, index) => (
                                    <div key={index}>
                                        <img
                                            src={image}
                                            alt={t('aboutSection.imageAlt', { index: index + 1 })}
                                            className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-xl"
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        {/* Paragraphs, centered */}
                        <div className="w-full space-y-6 text-center">
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.introParagraph1')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.introParagraph2')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.introParagraph3')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Layout for lg and larger screens: Text and Slider side by side */}
                <div className="hidden lg:block">
                    <div className="flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0">
                        {/* Left Side: Text Section */}
                        <div className="w-full md:w-1/2 space-y-6">
                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#122C56] mb-6 animate-fade-in drop-shadow-md">
                                {t('aboutSection.travelWithAshan')}
                            </h1>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.introParagraph1')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.introParagraph2')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.introParagraph3')}
                            </p>
                        </div>
                        {/* Right Side: Image Slider */}
                        <div className="w-full md:w-1/2 lg:ml-12">
                            <Slider {...sliderSettings} className="rounded-xl shadow-xl overflow-hidden">
                                {aboutImages.map((image, index) => (
                                    <div key={index}>
                                        <img
                                            src={image}
                                            alt={t('aboutSection.imageAlt', { index: index + 1 })}
                                            className="w-full h-64 sm:h-80 md:h-96 lg:h-[600px] object-cover rounded-xl"
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>

            {/* Cinnamon Luxury Villa Section */}
            <div className="max-w-7xl mx-auto mt-16">
                {/* Layout for sm and md screens: Title, Slider, Paragraphs, all centered */}
                <div className="block lg:hidden">
                    <div className="flex flex-col items-center space-y-8">
                        {/* Title, centered */}
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#122C56] mb-6 animate-fade-in text-center drop-shadow-md">
                            {t('aboutSection.cinnamonLuxuryVilla')}
                        </h2>
                        {/* Image Slider, centered */}
                        <div className="w-full max-w-3xl">
                            <Slider {...sliderSettings} className="rounded-xl shadow-xl overflow-hidden">
                                {villaImages.map((image, index) => (
                                    <div key={index}>
                                        <img
                                            src={image}
                                            alt={t('aboutSection.villaImageAlt', { index: index + 1 })}
                                            className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-xl"
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        {/* Paragraphs, centered */}
                        <div className="w-full space-y-6 text-center">
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.villaParagraph1')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.villaParagraph2')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                                {t('aboutSection.villaParagraph3')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Layout for lg and larger screens: Text and Slider side by side */}
                <div className="hidden lg:block">
                    <div className="flex flex-row items-center justify-between space-x-8">
                        {/* Left Side: Image Slider */}
                        <div className="w-1/2">
                            <Slider {...sliderSettings} className="rounded-xl shadow-xl overflow-hidden">
                                {villaImages.map((image, index) => (
                                    <div key={index}>
                                        <img
                                            src={image}
                                            alt={t('aboutSection.villaImageAlt', { index: index + 1 })}
                                            className="w-full h-64 sm:h-80 md:h-96 lg:h-[600px] object-cover rounded-xl"
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        {/* Right Side: Text Section */}
                        <div className="w-1/2 space-y-6">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#122C56] mb-6 animate-fade-in drop-shadow-md">
                                {t('aboutSection.cinnamonLuxuryVilla')}
                            </h2>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.villaParagraph1')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.villaParagraph2')}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl">
                                {t('aboutSection.villaParagraph3')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;